// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";

function V3Portal(props) {
  return React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
              id: props.id,
              children: props.children
            });
}

var make = V3Portal;

var $$default = V3Portal;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
